/* 产引入jsencrypt实现数据RSA加密 */
import JSEncrypt from 'jsencrypt' // 处理长文本数据时报错 jsencrypt.js Message too long for RSA
/* 产引入encryptlong实现数据RSA加密 */
import Encrypt from 'encryptlong' // encryptlong是基于jsencrypt扩展的长文本分段加解密功能。

// 公钥key
const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCbBrARExKBj3K7k+4oNiO9UPdnJuMjqHb+7fts4C6hGJJxRXKK1JpTORXyI/7I0eh3xTtodSAxYxYaqy2eRxcMqO4kKPKVarJHUJym0CwkRNj9OnCrXlKUW0pypmg+kd6VtluCEEioG1RCB9FnM1exI8mSCxbS+FZxeNLrWfz+DQIDAQAB'
// 私钥key
const privateKey = 'MIICWwIBAAKBgQCbBrARExKBj3K7k+4oNiO9UPdnJuMjqHb+7fts4C6hGJJxRXKK1JpTORXyI/7I0eh3xTtodSAxYxYaqy2eRxcMqO4kKPKVarJHUJym0CwkRNj9OnCrXlKUW0pypmg+kd6VtluCEEioG1RCB9FnM1exI8mSCxbS+FZxeNLrWfz+DQIDAQABAoGAdRaxBsRr9tU8p/aMK2zww32SzyMs7XLBJbzjaJFORriDavA0Gi2HvhHgxHlxZ4Y7WbLrMvM79HFNcakWlHRHMEa8vYdiUxkBpdzeN3h0N7WDlxGZAy8xb1uA6WFDKNEhEOZAaCzQesN+fDJKkMriqKQrlZuceyz6UlJxW2RcPpUCQQDfisDqhy7JBZiQnAaeaUUIBkZRVpwfHLT7Jrdw335FuNs/e98knAFwO2He5Pua+H0LbyURMDE7WKNX+5e5jPI3AkEAsYkj/ebdhQjIeNPSDWz09evKJhUTNm+SXL2EGOfFyymp+uiaJeaL7h9ow6u7ECYhNWGpht+70pIkTrzOcYP/2wJAeOPe5HZq9MeT9FCMu8qOTIKoMIC4OZMaxN/xQJd9AFOyLijdSj0cAgf7K8GF2A8eALsAvsTjOwb6fzBOo0f4DQJAeALqz6IWsO2FBxi5b9Xtqagg2Kl6eVvmpsZ925Ahxvp9K129hk1Y3jlhSpR2Oa5s2HcScFgh0XB1FrzPGTFP7QJAHd4oA3uENH0L5dIidvL4CPDguSKeTYGPEDrK0ip5uh07uxbUSbDnhsy9JxDoH87GHx17M5IBAN3nKfjAAq/xtQ=='

/* JSEncrypt加密 */
export function rsaPublicData(data) {
    var jsencrypt = new JSEncrypt()
    jsencrypt.setPublicKey(publicKey)
    // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
    var result = jsencrypt.encrypt(data)
    return result
}
/* JSEncrypt解密 */
export function rsaPrivateData(data) {
    var jsencrypt = new JSEncrypt()
    jsencrypt.setPrivateKey(privateKey)
    // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
    var result = jsencrypt.encrypt(data)
    return result
}
/* 加密 */
export function encrypt(data) {
    const PUBLIC_KEY = publicKey
    var encryptor = new Encrypt()
    encryptor.setPublicKey(PUBLIC_KEY)
    // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
    const result = encryptor.encryptLong(data)
    return result
}
/* 解密 - PRIVATE_KEY - 验证 */
export function decrypt(data) {
    const PRIVATE_KEY = privateKey
    var encryptor = new Encrypt()
    encryptor.setPrivateKey(PRIVATE_KEY)
    // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
    var result = encryptor.decryptLong(data)
    return result
}